/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateHchbPatientRequest201Response,
  CreateHchbPatientRequestBody,
  CreateMatrixCareHomeHealthPatient409Response,
  CreateMatrixCareHomeHealthPatientRequest,
  FindAllHchbAdmissionCoordinators200Response,
  FindAllHchbBranches200Response,
  FindAllHchbFacilities200Response,
  FindAllHchbPatientRequests200Response,
  FindAllHchbPayorSources200Response,
  FindAllHchbPayorTypes200Response,
  FindAllHchbPhysicians200Response,
  FindOneHchbPatientDetails200Response,
  GetMatrixCareHomeHealthAdmission200Response,
  GetMatrixCareHomeHealthLookups200Response,
  LookupZipOptions200Response,
  StartExecution202Response,
  StartExecutionRequest,
  UploadHchbDocumentsRequest,
} from '../models/index';
import {
    CreateHchbPatientRequest201ResponseFromJSON,
    CreateHchbPatientRequest201ResponseToJSON,
    CreateHchbPatientRequestBodyFromJSON,
    CreateHchbPatientRequestBodyToJSON,
    CreateMatrixCareHomeHealthPatient409ResponseFromJSON,
    CreateMatrixCareHomeHealthPatient409ResponseToJSON,
    CreateMatrixCareHomeHealthPatientRequestFromJSON,
    CreateMatrixCareHomeHealthPatientRequestToJSON,
    FindAllHchbAdmissionCoordinators200ResponseFromJSON,
    FindAllHchbAdmissionCoordinators200ResponseToJSON,
    FindAllHchbBranches200ResponseFromJSON,
    FindAllHchbBranches200ResponseToJSON,
    FindAllHchbFacilities200ResponseFromJSON,
    FindAllHchbFacilities200ResponseToJSON,
    FindAllHchbPatientRequests200ResponseFromJSON,
    FindAllHchbPatientRequests200ResponseToJSON,
    FindAllHchbPayorSources200ResponseFromJSON,
    FindAllHchbPayorSources200ResponseToJSON,
    FindAllHchbPayorTypes200ResponseFromJSON,
    FindAllHchbPayorTypes200ResponseToJSON,
    FindAllHchbPhysicians200ResponseFromJSON,
    FindAllHchbPhysicians200ResponseToJSON,
    FindOneHchbPatientDetails200ResponseFromJSON,
    FindOneHchbPatientDetails200ResponseToJSON,
    GetMatrixCareHomeHealthAdmission200ResponseFromJSON,
    GetMatrixCareHomeHealthAdmission200ResponseToJSON,
    GetMatrixCareHomeHealthLookups200ResponseFromJSON,
    GetMatrixCareHomeHealthLookups200ResponseToJSON,
    LookupZipOptions200ResponseFromJSON,
    LookupZipOptions200ResponseToJSON,
    StartExecution202ResponseFromJSON,
    StartExecution202ResponseToJSON,
    StartExecutionRequestFromJSON,
    StartExecutionRequestToJSON,
    UploadHchbDocumentsRequestFromJSON,
    UploadHchbDocumentsRequestToJSON,
} from '../models/index';

export interface CreateHchbPatientRequestRequest {
    createHchbPatientRequestBody: CreateHchbPatientRequestBody;
}

export interface CreateMatrixCareHomeHealthPatientOperationRequest {
    leadId: string;
    createMatrixCareHomeHealthPatientRequest: CreateMatrixCareHomeHealthPatientRequest;
}

export interface FindAllHchbAdmissionCoordinatorsRequest {
    facilityId: string;
    search?: string;
    page?: number;
    limit?: number;
}

export interface FindAllHchbBranchesRequest {
    facilityId: string;
}

export interface FindAllHchbFacilitiesRequest {
    facilityId: string;
    search?: string;
    searchable?: boolean;
    page?: number;
    limit?: number;
}

export interface FindAllHchbPatientRequestsRequest {
    leadId: string;
}

export interface FindAllHchbPayorSourcesRequest {
    payorTypeId: string;
    search?: string;
    serviceLineType?: string;
    page?: number;
    limit?: number;
}

export interface FindAllHchbPayorTypesRequest {
    facilityId: string;
    search?: string;
    serviceLineType?: string;
    page?: number;
    limit?: number;
}

export interface FindAllHchbPhysiciansRequest {
    facilityId: string;
    search?: string;
    searchable?: boolean;
    page?: number;
    limit?: number;
}

export interface FindOneHchbPatientDetailsRequest {
    leadId: string;
}

export interface GetMatrixCareHomeHealthAdmissionRequest {
    leadId: string;
}

export interface GetMatrixCareHomeHealthLookupsRequest {
    leadId: string;
    businessUnitId?: string;
}

export interface LookupZipOptionsRequest {
    facilityId: string;
    zip: string;
}

export interface StartExecutionOperationRequest {
    startExecutionRequest: StartExecutionRequest;
}

export interface UploadHchbDocumentsOperationRequest {
    leadId: string;
    uploadHchbDocumentsRequest: UploadHchbDocumentsRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Create an HCHB patient creation request
     */
    async createHchbPatientRequestRaw(requestParameters: CreateHchbPatientRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateHchbPatientRequest201Response>> {
        if (requestParameters['createHchbPatientRequestBody'] == null) {
            throw new runtime.RequiredError(
                'createHchbPatientRequestBody',
                'Required parameter "createHchbPatientRequestBody" was null or undefined when calling createHchbPatientRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/homecare-homebase/patient-requests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateHchbPatientRequestBodyToJSON(requestParameters['createHchbPatientRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateHchbPatientRequest201ResponseFromJSON(jsonValue));
    }

    /**
     * Create an HCHB patient creation request
     */
    async createHchbPatientRequest(requestParameters: CreateHchbPatientRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateHchbPatientRequest201Response> {
        const response = await this.createHchbPatientRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enqueue a MatrixCare Home Health patient creation. Handled asynchronously by the uploader worker.
     */
    async createMatrixCareHomeHealthPatientRaw(requestParameters: CreateMatrixCareHomeHealthPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createMatrixCareHomeHealthPatient().'
            );
        }

        if (requestParameters['createMatrixCareHomeHealthPatientRequest'] == null) {
            throw new runtime.RequiredError(
                'createMatrixCareHomeHealthPatientRequest',
                'Required parameter "createMatrixCareHomeHealthPatientRequest" was null or undefined when calling createMatrixCareHomeHealthPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/matrix-care-home-health/leads/{lead_id}/patient`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMatrixCareHomeHealthPatientRequestToJSON(requestParameters['createMatrixCareHomeHealthPatientRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Enqueue a MatrixCare Home Health patient creation. Handled asynchronously by the uploader worker.
     */
    async createMatrixCareHomeHealthPatient(requestParameters: CreateMatrixCareHomeHealthPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createMatrixCareHomeHealthPatientRaw(requestParameters, initOverrides);
    }

    /**
     * Search HCHB admission coordinators
     */
    async findAllHchbAdmissionCoordinatorsRaw(requestParameters: FindAllHchbAdmissionCoordinatorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbAdmissionCoordinators200Response>> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllHchbAdmissionCoordinators().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/admission-coordinators`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbAdmissionCoordinators200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB admission coordinators
     */
    async findAllHchbAdmissionCoordinators(requestParameters: FindAllHchbAdmissionCoordinatorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbAdmissionCoordinators200Response> {
        const response = await this.findAllHchbAdmissionCoordinatorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List HCHB branches with teams for a facility
     */
    async findAllHchbBranchesRaw(requestParameters: FindAllHchbBranchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbBranches200Response>> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllHchbBranches().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/branches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbBranches200ResponseFromJSON(jsonValue));
    }

    /**
     * List HCHB branches with teams for a facility
     */
    async findAllHchbBranches(requestParameters: FindAllHchbBranchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbBranches200Response> {
        const response = await this.findAllHchbBranchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search HCHB facilities
     */
    async findAllHchbFacilitiesRaw(requestParameters: FindAllHchbFacilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbFacilities200Response>> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllHchbFacilities().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['searchable'] != null) {
            queryParameters['searchable'] = requestParameters['searchable'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/facilities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbFacilities200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB facilities
     */
    async findAllHchbFacilities(requestParameters: FindAllHchbFacilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbFacilities200Response> {
        const response = await this.findAllHchbFacilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List HCHB patient requests for a lead
     */
    async findAllHchbPatientRequestsRaw(requestParameters: FindAllHchbPatientRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbPatientRequests200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findAllHchbPatientRequests().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['leadId'] != null) {
            queryParameters['lead_id'] = requestParameters['leadId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/patient-requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbPatientRequests200ResponseFromJSON(jsonValue));
    }

    /**
     * List HCHB patient requests for a lead
     */
    async findAllHchbPatientRequests(requestParameters: FindAllHchbPatientRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbPatientRequests200Response> {
        const response = await this.findAllHchbPatientRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search HCHB payor sources
     */
    async findAllHchbPayorSourcesRaw(requestParameters: FindAllHchbPayorSourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbPayorSources200Response>> {
        if (requestParameters['payorTypeId'] == null) {
            throw new runtime.RequiredError(
                'payorTypeId',
                'Required parameter "payorTypeId" was null or undefined when calling findAllHchbPayorSources().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['payorTypeId'] != null) {
            queryParameters['payor_type_id'] = requestParameters['payorTypeId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['serviceLineType'] != null) {
            queryParameters['service_line_type'] = requestParameters['serviceLineType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/payor-sources`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbPayorSources200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB payor sources
     */
    async findAllHchbPayorSources(requestParameters: FindAllHchbPayorSourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbPayorSources200Response> {
        const response = await this.findAllHchbPayorSourcesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search HCHB payor types
     */
    async findAllHchbPayorTypesRaw(requestParameters: FindAllHchbPayorTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbPayorTypes200Response>> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllHchbPayorTypes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['serviceLineType'] != null) {
            queryParameters['service_line_type'] = requestParameters['serviceLineType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/payor-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbPayorTypes200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB payor types
     */
    async findAllHchbPayorTypes(requestParameters: FindAllHchbPayorTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbPayorTypes200Response> {
        const response = await this.findAllHchbPayorTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search HCHB physicians
     */
    async findAllHchbPhysiciansRaw(requestParameters: FindAllHchbPhysiciansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHchbPhysicians200Response>> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllHchbPhysicians().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['searchable'] != null) {
            queryParameters['searchable'] = requestParameters['searchable'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/physicians`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHchbPhysicians200ResponseFromJSON(jsonValue));
    }

    /**
     * Search HCHB physicians
     */
    async findAllHchbPhysicians(requestParameters: FindAllHchbPhysiciansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHchbPhysicians200Response> {
        const response = await this.findAllHchbPhysiciansRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find One HCHB patient\'s details
     */
    async findOneHchbPatientDetailsRaw(requestParameters: FindOneHchbPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneHchbPatientDetails200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findOneHchbPatientDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/leads/{lead_id}/patient-details`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneHchbPatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Find One HCHB patient\'s details
     */
    async findOneHchbPatientDetails(requestParameters: FindOneHchbPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneHchbPatientDetails200Response> {
        const response = await this.findOneHchbPatientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the latest MatrixCare Home Health admission for a lead.
     */
    async getMatrixCareHomeHealthAdmissionRaw(requestParameters: GetMatrixCareHomeHealthAdmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMatrixCareHomeHealthAdmission200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getMatrixCareHomeHealthAdmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/matrix-care-home-health/leads/{lead_id}/admission`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMatrixCareHomeHealthAdmission200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the latest MatrixCare Home Health admission for a lead.
     */
    async getMatrixCareHomeHealthAdmission(requestParameters: GetMatrixCareHomeHealthAdmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMatrixCareHomeHealthAdmission200Response> {
        const response = await this.getMatrixCareHomeHealthAdmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch all picklists needed to render the MatrixCare Home Health create-patient form.
     */
    async getMatrixCareHomeHealthLookupsRaw(requestParameters: GetMatrixCareHomeHealthLookupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMatrixCareHomeHealthLookups200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getMatrixCareHomeHealthLookups().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['businessUnitId'] != null) {
            queryParameters['business_unit_id'] = requestParameters['businessUnitId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/matrix-care-home-health/leads/{lead_id}/lookups`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMatrixCareHomeHealthLookups200ResponseFromJSON(jsonValue));
    }

    /**
     * Fetch all picklists needed to render the MatrixCare Home Health create-patient form.
     */
    async getMatrixCareHomeHealthLookups(requestParameters: GetMatrixCareHomeHealthLookupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMatrixCareHomeHealthLookups200Response> {
        const response = await this.getMatrixCareHomeHealthLookupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Look up city/state/county options for a zip code
     */
    async lookupZipOptionsRaw(requestParameters: LookupZipOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LookupZipOptions200Response>> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling lookupZipOptions().'
            );
        }

        if (requestParameters['zip'] == null) {
            throw new runtime.RequiredError(
                'zip',
                'Required parameter "zip" was null or undefined when calling lookupZipOptions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['zip'] != null) {
            queryParameters['zip'] = requestParameters['zip'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/homecare-homebase/zip-lookup`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LookupZipOptions200ResponseFromJSON(jsonValue));
    }

    /**
     * Look up city/state/county options for a zip code
     */
    async lookupZipOptions(requestParameters: LookupZipOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LookupZipOptions200Response> {
        const response = await this.lookupZipOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start an HCHB automation execution
     */
    async startExecutionRaw(requestParameters: StartExecutionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartExecution202Response>> {
        if (requestParameters['startExecutionRequest'] == null) {
            throw new runtime.RequiredError(
                'startExecutionRequest',
                'Required parameter "startExecutionRequest" was null or undefined when calling startExecution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/homecare-homebase/executions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartExecutionRequestToJSON(requestParameters['startExecutionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StartExecution202ResponseFromJSON(jsonValue));
    }

    /**
     * Start an HCHB automation execution
     */
    async startExecution(requestParameters: StartExecutionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartExecution202Response> {
        const response = await this.startExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload documents to HCHB
     */
    async uploadHchbDocumentsRaw(requestParameters: UploadHchbDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneHchbPatientDetails200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling uploadHchbDocuments().'
            );
        }

        if (requestParameters['uploadHchbDocumentsRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadHchbDocumentsRequest',
                'Required parameter "uploadHchbDocumentsRequest" was null or undefined when calling uploadHchbDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/homecare-homebase/leads/{lead_id}/patient-documents`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadHchbDocumentsRequestToJSON(requestParameters['uploadHchbDocumentsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneHchbPatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Upload documents to HCHB
     */
    async uploadHchbDocuments(requestParameters: UploadHchbDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneHchbPatientDetails200Response> {
        const response = await this.uploadHchbDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
